var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.036 12.312a5.277 5.277 0 1 0-5.277-5.276 5.277 5.277 0 0 0 5.277 5.277zm5.558-.962l3.148 3.15a.879.879 0 1 1-1.242 1.241l-3.148-3.149a7.036 7.036 0 1 1 1.244-1.244z",
    transform: "translate(.001 .001)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-thin.12d6d296362925419b1c4333c9d8fbf1.svg";